import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.13_typescript@4.8.4_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];